import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/locales'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/login/index'),
    name: 'login',
    meta: { title: 'lang.title.login' }
  },
  {
    path: '/quickView',
    component: () => import('@/views/login/QuickView'),
    name: 'quickView',
    meta: { title: 'lang.title.ssoCallback' }
  },
  {
    path: '/quickQuery',
    component: () => import('@/views/login/QuickQuery'),
    name: 'quickQuery',
    meta: {
      title: 'lang.title.quickQuery'
    }
  },
  {
    path: '/ssoCallback',
    name: 'ssoCallback',
    component: () => import('@/views/login/ssoCallback'),
    meta: {
      title: 'lang.title.ssoCallback'
    }
  },
  {
    path: '/confirmInfo',
    name: 'confirmInfo',
    component: () => import('@/views/apply/confirmInfo/index'),
    meta: {
      title: 'lang.title.confirmInfo'
    }
  },
  {
    path: '/confirmPack',
    name: 'confirmPack',
    component: () => import('@/views/apply/confirmPack/index'),
    meta: {
      title: 'lang.title.confirmPack'
    }
  },
  {
    path: '/confirmReceiveInfo',
    name: 'confirmReceiveInfo',
    component: () => import('@/views/apply/confirmReceiveInfo/index'),
    meta: {
      title: 'lang.title.confirmReceiveInfo'
    }
  },
  {
    path: '/submit',
    name: 'submit',
    component: () => import('@/views/apply/submit/index'),
    meta: {
      title: 'lang.title.submit'
    }
  },
  {
    path: '/applyList',
    name: 'applyList',
    component: () => import('@/views/apply/record/list'),
    meta: {
      title: 'lang.title.applyList'
    }
  },
  {
    path: '/applyDetail',
    name: 'applyDetail',
    component: () => import('@/views/apply/record/detail'),
    meta: {
      title: 'lang.title.applyDetail'
    }
  }
  // {
  //     path: '/apply/electronic',
  //     component: () => import('@/views/apply/electronic'),
  //     meta: {title: '电子版'}
  // },
  // {
  //     path: '/apply/paper',
  //     component: () => import('@/views/apply/paper'),
  //     meta: {title: '纸质版'}
  // },
  // {
  //     path: '/apply/package',
  //     component: () => import('@/views/apply/package'),
  //     meta: {title: '文件装袋'}
  // },
  // {
  //     path: '/apply/gettype',
  //     component: () => import('@/views/apply/gettype'),
  //     meta: {title: '领取方式'}
  // },
  // {
  //     path: '/apply/submit',
  //     component: () => import('@/views/apply/submit'),
  //     meta: {title: '提交申请'}
  // }
]
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()
// const whiteList = ['/login'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  document.title = `${i18n.t(to.meta.title)}`
  next()
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = `${i18n.t(to.meta.title)}`
  } else {
    document.title = ''
  }
})

export default router
